import { getToken } from './tokenUtils';

export const getImageUrlWithToken = (url) => {
  const token = getToken();
  if (!url) return '';
  // console.log(`${url}?token=${token}`);
  return `${url}?token=${token}`;
};



